import type { BetterstartIntegrationId } from '@cli-types/integration-engine/integrations.js'
import { parseIdList } from '@core-engine/installable/protocol/parse-id-list.js'
import {
  formatUnknownIntegrationMessage,
  isIntegrationId
} from '@next-adapter/integration-registry.js'

export function parseIntegrationList(value: string | undefined): BetterstartIntegrationId[] {
  return parseIdList(value, isIntegrationId, formatUnknownIntegrationMessage)
}
